import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import PageTransition from '../components/PageTransition';

export default function Login() {
  const { user, handleGoogleSuccess } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/');
  }, [user, navigate]);

  return (
    <PageTransition>
      <div style={{ maxWidth: '400px', margin: '5rem auto', textAlign: 'center', padding: '0 2rem' }}>
        <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.8rem', marginBottom: '0.5rem', fontWeight: 400 }}>
          Join the Understory
        </h2>
        <p style={{ color: 'var(--text-tertiary)', fontSize: '0.95rem', marginBottom: '2.5rem', lineHeight: 1.5 }}>
          Sign in with Google to comment on posts and join the UMI community.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => console.error('Google login failed')}
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>
        <p style={{ color: 'var(--text-tertiary)', fontSize: '0.75rem', lineHeight: 1.5 }}>
          Admin access is granted to emails listed in the environment config.
        </p>
      </div>
    </PageTransition>
  );
}